import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl99WithAllFilesValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPraktFile: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup.date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")).required(t("Το πεδίο είναι υποχρεωτικό")),
    d55_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocGsFile: yup
      .string()
      .notRequired()
      .test(
        "fudocGsFile-check",
        t("Εισάγατε ημερομηνία Αρχείου Πρακτικού ΓΣ αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docGsFileDate, fudocGsFile } = context.parent;
          return !(!fudocGsFile && docGsFileDate);
        },
      ),
    docGsFileDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docGsFileDate-check",
        t(
          "Εισάγατε Αρχείο Πρακτικού ΓΣ αλλά όχι και την ημερομηνία του Αρχείου.",
        ),
        (value, context) => {
          const { fudocGsFile, docGsFileDate } = context.parent;
          return !(!docGsFileDate && fudocGsFile);
        },
      ),
    fudocDsFile: yup
      .string()
      .notRequired()
      .test(
        "fudocDsFile-check",
        t("Εισάγατε ημερομηνία Αρχείου Πρακτικού ΔΣ αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docDsFileDate, fudocDsFile } = context.parent;
          return !(!fudocDsFile && docDsFileDate);
        },
      ),
    docDsFileDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docDsFileDate-check",
        t(
          "Εισάγατε Αρχείο Πρακτικού ΔΣ αλλά όχι και την ημερομηνία του Αρχείου.",
        ),
        (value, context) => {
          const { fudocDsFile, docDsFileDate } = context.parent;
          return !(!docDsFileDate && fudocDsFile);
        },
      ),
    fudocStatute: yup
      .string()
      .notRequired()
      .test(
        "fudocStatute-check",
        t("Εισάγατε ημερομηνία Αρχείου Καταστατικού αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docStatuteFileDate, fudocStatute } = context.parent;
          return !(!fudocStatute && docStatuteFileDate);
        },
      ),
    docStatuteFileDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docStatuteFileDate-check",
        t(
          "Εισάγατε Αρχείο Καταστατικού αλλά όχι και την ημερομηνία του Αρχείου.",
        ),
        (value, context) => {
          const { fudocStatute, docStatuteFileDate } = context.parent;
          return !(!docStatuteFileDate && fudocStatute);
        },
      ),
    fudocSelectedType: yup
      .string()
      .notRequired()
      .test(
        "fudocSelectedType-check",
        t("Εισάγατε ημερομηνία Λοιπών Αρχείων αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docSelectedTypeDate, fudocSelectedType } = context.parent;
          return !(!fudocSelectedType && docSelectedTypeDate);
        },
      ),
    docSelectedTypeDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docSelectedTypeDate-check",
        t("Εισάγατε Λοιπά Αρχεία αλλά όχι και την ημερομηνία του Αρχείου."),
        (value, context) => {
          const { fudocSelectedType, docSelectedTypeDate } = context.parent;
          return !(!docSelectedTypeDate && fudocSelectedType);
        },
      ),
    fudocLoipa: yup
      .string()
      .notRequired()
      .test(
        "fudocLoipa-check",
        t("Εισάγατε ημερομηνία Λοιπών Εγγράφων αλλά όχι και το έγγραφο."),
        (value, context) => {
          const { docLoipaFileDate, fudocLoipa } = context.parent;
          return !(!fudocLoipa && docLoipaFileDate);
        },
      ),
    docLoipaFileDate: yup
      .date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .notRequired()
      .test(
        "docLoipaFileDate-check",
        t("Εισάγατε Λοιπά Έγγραφα αλλά όχι και την ημερομηνία του Εγγράφου."),
        (value, context) => {
          const { fudocLoipa, docLoipaFileDate } = context.parent;
          return !(!docLoipaFileDate && fudocLoipa);
        },
      ),
  });
};
